// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder__fqrpQ"};